import { getPostData  } from "../api"
import { toastError, toastWarn } from "../../global/errors.toast";
import {
    GET_BLOG_REQUEST,
    GET_BLOG_SUCCESS,
    GET_BLOG_FAILURE,
} from "../const";


const request = () => ({ type: GET_BLOG_REQUEST});

const success = (posts, page) => ({
    type: GET_BLOG_SUCCESS,
    payload: { posts, page },
});
const failure = () => ({ type: GET_BLOG_FAILURE});

export const receivePosts = (params) => async (dispatch) => {
    dispatch(request());
    try {
        const { data: receivePostData } = await getPostData(params).catch((error)=> {
            if (error.response.status === 400) {
                toastWarn(`${error.response.status} Bad request`)
            } else {
                if (error.response.status === 500) {
                    toastError(`${error.response.status} Server error`)
                }
            }})
        dispatch(success(receivePostData, params.page));
    } catch (e) {
        
        dispatch(failure());
    };
};